import { IIndexable } from '../model/IIndexable';
import { Banner } from '@bpba/modules-components';
import { RubroData } from '../model/RubroData';

export function bannersMapping(item: IIndexable) {
  const banner = Banner.fromJsonObject(item);
  banner.enlace = RubroData.getLink(item?.rubroId);

  return banner;
}
